import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { Control } from 'react-hook-form';
import { RegistrationField } from '../../../../../../interfaces/interfaces';
import VyMultiSelect from '../../../../../common/VyMultiSelect';

interface FilterFieldInterface {
  field: RegistrationField;
  fieldValues?: string[];
  onChange: (values: string[]) => void;
}

const FilterField = ({ field, fieldValues = [], onChange }: FilterFieldInterface) => {
  const { t } = useTranslation();

  const onValueChange = (value: string) => {
    const _values = [...fieldValues];
    const index = _values.indexOf(value);
    if (index >= 0) _values.splice(index, 1);
    else _values.push(value);
    onChange(_values);
  };

  const renderFieldInput = () => {
    if (field.fieldType === 'checkbox')
      return (
        <div>
          <FormControlLabel
            sx={{
              '& svg': {
                width: '0.5em',
                height: '0.5em',
              },
            }}
            value="true"
            control={<Checkbox checked={fieldValues.includes('true')} />}
            onChange={(e) => onValueChange('true')}
            label={field.trueText || t(`event:registration.checkbox-true`).toString()}
          />
          <FormControlLabel
            sx={{
              '& svg': {
                width: '0.5em',
                height: '0.5em',
              },
            }}
            value="false"
            control={<Checkbox checked={fieldValues.includes('false')} />}
            label={field.falseText || t(`event:registration.checkbox-false`).toString()}
            onChange={(e) => onValueChange('false')}
          />
        </div>
      );

    return (
      <VyMultiSelect
        name={field._id}
        selectedOptions={fieldValues.map((v) => ({ name: v, value: v }))}
        options={field.textValueOptions.map((tvo) => ({ name: tvo.content, value: tvo.content }))}
        onValueChange={(values) => onChange(values)}
      />
    );
  };

  return (
    <div className="flex flex-col w-full justify-between">
      <p className="text-gray-500">{field.label}</p>
      {renderFieldInput()}
    </div>
  );
};
export default FilterField;
